var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('DataTable',{attrs:{"title":"LISTADO DE CITAS VIRTUALES","headers":_vm.headers,"items":_vm.appointmentList,"borderRadius":10,"loading":_vm.loadingTable,"itemKey":"bookingCode","hide-default-footer":false,"items-per-page":10,"height":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }